<template>
  <van-popup v-model="show" position="bottom" :style="{ height: '90vh' }" round>
    <div class="health-info">
      <div class="health-info__header">
        <div class="health-info__title">健康信息</div>
        <div class="health-info__close" @click="handleClose">
          <i class="iconfont icon-close"></i>
        </div>
      </div>
      <div class="health-info__content">
        <div class="health-section" v-for="(section, key) in form" :key="key">
          <template v-if="typeof section === 'object'">
            <div class="section-header">
              <div class="section-title">{{ getSectionTitle(key) }}</div>
              <van-radio-group v-model="section.has" direction="horizontal" :checked="section.has">
                <van-radio :name="false" checked-color="$appcolor">无</van-radio>
                <van-radio :name="true" checked-color="$appcolor">有</van-radio>
              </van-radio-group>
            </div>
            <div class="options-container" v-if="section.has">
              <div class="options-grid">
                <div
                  v-for="(option, index) in getOptions(key)"
                  :key="index"
                  class="option-item"
                  :class="{ active: section.selected.includes(option) }"
                  @click="key === 'nurseType' ? toggleSingleOption(key, option) : toggleOption(key, option)"
                >
                  {{ option }}
                </div>
              </div>
              <div class="remark-input" v-if="false && key !== 'nurseType'">
                <van-field
                  v-model="section.remark"
                  type="textarea"
                  placeholder="请补充说明的详细情况"
                  :maxlength="200"
                  rows="3"
                  show-word-limit
                  autosize
                />
              </div>
            </div>
          </template>
        </div>

        <div class="health-section">
          <div class="section-header">
            <div class="section-title">肝功能</div>
            <van-radio-group v-model="form.liverType" direction="horizontal">
              <van-radio :name="0" checked-color="$appcolor">正常</van-radio>
              <van-radio :name="1" checked-color="$appcolor">异常</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="health-section">
          <div class="section-header">
            <div class="section-title">肾功能</div>
            <van-radio-group v-model="form.renalType" direction="horizontal">
              <van-radio :name="0" checked-color="$appcolor">正常</van-radio>
              <van-radio :name="1" checked-color="$appcolor">异常</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
    </div>
    <fixed-button @click="handleSubmit" @emitEvent="handleSubmit">确定</fixed-button>
  </van-popup>
</template>

<script>
import { Popup, RadioGroup, Radio, Field } from 'vant';
import FixedButton from '@/components/fixedButton';

export default {
  name: 'HealthInfo',
  components: {
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    FixedButton
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    healthData: {
      type: Object,
      default: () => ({
        pmhType: { has: false, selected: [], remark: '' },
        drugAllergyType: { has: false, selected: [], remark: '' },
        foodAllergyType: { has: false, selected: [], remark: '' },
        contactAllergyType: { has: false, selected: [], remark: '' },
        fmhType: { has: false, selected: [], remark: '' },
        liverType: 0,
        renalType: 0,
        nurseType: { has: false, selected: [] }
      })
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(this.healthData)),
      pmhTypeOptions: ['高血压', '心脑血管疾病', '高血脂', '肝炎', '高尿酸血症', '支气管哮喘', '结核病', '肾病'],
      drugAllergyTypeOptions: ['青霉素', '头孢抗生素', '磺胺类抗菌素(TMP)', '普通感冒药', '镇痛类药物'],
      foodAllergyTypeOptions: ['贝类', '鱼类', '虾类', '蛋类', '牛奶'],
      contactAllergyTypeOptions: ['粉尘', '蚊虫', '花粉', '动物毛发', '酒精'],
      fmhTypeOptions: ['高血压', '糖尿病', '癌症', '脑出血', '痛风', '近视', '精神疾病', '白癜风'],
      nurseTypeOptions: ['备孕中', '怀孕中', '正在哺乳']
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    healthData: {
      handler(val) {
        if (Object.keys(val).length) {
          this.form = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.show = false;
    },
    toggleHistory(type, value) {
      this.form[type].has = value;
      if (!value) {
        this.form[type].selected = [];
        this.form[type].remark = '';
      }
    },
    toggleOption(type, option) {
      const index = this.form[type].selected.indexOf(option);
      if (index > -1) {
        this.form[type].selected.splice(index, 1);
      } else {
        this.form[type].selected.push(option);
      }
    },
    toggleSingleOption(type, option) {
      this.form[type].selected = [option];
    },
    handleSubmit() {
      for (const [key, section] of Object.entries(this.form)) {
        if (typeof section === 'object' && section.has && section.selected.length === 0) {
          const title = this.getSectionTitle(key);
          this.$toast(`请选择${title}的具体选项`);
          return;
        }
      }
      this.$emit('submit', JSON.parse(JSON.stringify(this.form)));
      this.show = false;
    },
    getSectionTitle(key) {
      const titles = {
        pmhType: '过往病史',
        drugAllergyType: '药物过敏史',
        foodAllergyType: '食物过敏史',
        contactAllergyType: '接触过敏史',
        fmhType: '家族遗传病史',
        nurseType: '妊娠哺乳'
      };
      return titles[key];
    },
    getOptions(key) {
      const optionsMap = {
        pmhType: this.pmhTypeOptions,
        drugAllergyType: this.drugAllergyTypeOptions,
        foodAllergyType: this.foodAllergyTypeOptions,
        contactAllergyType: this.contactAllergyTypeOptions,
        fmhType: this.fmhTypeOptions,
        nurseType: this.nurseTypeOptions
      };
      return optionsMap[key];
    }
  }
};
</script>

<style lang="scss" scoped>
.health-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;

  &__header {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-bottom: 1px solid #f5f5f5;
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  &__close {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    color: #999;
  }

  &__content {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    padding-bottom: 80px;
  }
}

.health-section {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  :deep(.van-radio-group) {
    display: flex;
    gap: 20px;
  }

  :deep(.van-radio) {
    margin-right: 0;
  }

  :deep(.van-radio__label) {
    color: #666;
  }

  :deep(.van-radio__icon) {
    .van-icon {
      border-color: #ddd;
    }
  }
}

.section-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 0;
}

.options-container {
  margin-bottom: 12px;
}

.options-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.option-item {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 14px;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;

  &.active {
    background: rgba($appcolor, 0.1);
    color: $appcolor;
    border-color: $appcolor;
  }

  &:active {
    opacity: 0.8;
  }
}

.remark-input {
  margin-top: 12px;
  width: 100%;

  :deep(.van-field) {
    padding: 0;
    background: transparent;

    .van-field__word-limit {
      margin-top: 4px;
      text-align: right;
    }

    .van-field__control {
      min-height: 80px;
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;

      &:focus {
        border-color: $appcolor;
      }
    }
  }
}

.word-count {
  display: none;
}
</style>
